import React from "react";
import { observer } from "mobx-react";
import { EventOffer } from "@gp/offer";
import useTime from "@hooks/useDayAndTimeFromEventStartTime";

export const EventMatchTime = observer(function EventMatchTime(props: {
	event: EventOffer;
}) {
	const { day, time } = useTime(props.event.startTime);

	return (
		<div className="event__middle__start">
			<span className="event__middle__time">{time}</span>
			<span className="event__middle__day">{day}</span>
		</div>
	);
});
